module.exports = __webpack_public_path__ + "static/media/quindio-14.e985a9b1.jpg";